import Dropdown from "../Dropdown";
import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik";
import { ReactNode } from "react";
import { FormProps } from "../../../interface";

interface AppFormProps<TValues = any> extends FormProps<TValues> {
  children?: (args: {
    isSubmitting: boolean;
    isValid: boolean;
    setFieldValue: (field: string, value: any) => void;
  }) => ReactNode;
  onInputChange?: (fieldName: string, value: string) => void;
}

const AppForm = ({
  inputFields,
  initialValues,
  schema,
  handleSubmit,
  options,
  children,
  dropDownLabels,
  dropDownOptions,
  onInputChange,
}: AppFormProps) => {
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={schema}
      enableReinitialize
      onSubmit={handleSubmit}
    >
      {({ isSubmitting, isValid, setFieldValue, values }) => {
        return (
          <Form id="userForm">
            {inputFields.map((field) => ((field.visibilityDependant && values[field.visibilityDependant]) || !field.visibilityDependant) && (
              <div key={field.name} className={`mt-3 ${field.type === "checkbox" ? "form-check form-switch" : ""}`}>
                <label htmlFor={field.name} className="form-label">
                  {field.label}
                </label>

                {field.type === "dynamic" ? (
                  <FieldArray
                    name={field.name}
                    render={(arrayHelpers) => (
                      <div>
                        {values[field.name] && values[field.name].length > 0 ? (
                          values[field.name].map((_: string, index: number) => (
                            <div
                              key={index}
                              className="d-flex align-items-center gap-2 mb-2"
                            >
                              <Field
                                name={`${field.name}.${index}`}
                                placeholder={`${field.label} ${index + 1}`}
                                className="form-control"
                                onInput={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  if (onInputChange) {
                                    onInputChange(
                                      `${field.name}.${index}`,
                                      e.target.value
                                    );
                                  }
                                }}
                              />
                              <button
                                type="button"
                                className="btn btn-outline-danger btn-sm"
                                onClick={() => arrayHelpers.remove(index)}
                              >
                                ❌
                              </button>
                            </div>
                          ))
                        ) : (
                          <div>No {field.label} added</div>
                        )}

                        <button
                          type="button"
                          className="btn btn-sm mt-2"
                          style={{
                            border: `1px solid #4fd1c5`,
                            color: "#4fd1c5",
                            backgroundColor: "transparent",
                            transition: "all 0.2s ease-in-out",
                            fontWeight: "500",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#4fd1c5";
                            e.currentTarget.style.color = "white";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor =
                              "transparent";
                            e.currentTarget.style.color = "#4fd1c5";
                          }}
                          onClick={() => arrayHelpers.push("")}
                        >
                          + Add Another {field.label}
                        </button>

                        <ErrorMessage
                          name={field.name}
                          component="div"
                          className="text-danger small"
                        />
                      </div>
                    )}
                  />
                ) :(
                  <>
                    <Field
                      name={field.name}
                      id={field.name}
                      type={field.type}
                      className={field.type === "checkbox" ? "form-check-input" : "form-control"}
                      // style={field.type === "checkbox" ? {margin} : {}}
                      placeholder={field.placeholder}
                      onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
                        if (onInputChange) {
                          onInputChange(field.name, e.target.value);
                        }
                      }}
                    />
                    <ErrorMessage
                      name={field.name}
                      component="div"
                      className="text-danger small"
                    />
                  </>
                )}
              </div>
            ))}

            {options && (
              <Field name="user_role">
                {({ field, meta }: any) => (
                  <Dropdown
                    name={field.name}
                    label={dropDownLabels}
                    value={field.value}
                    onChange={field.onChange}
                    options={dropDownOptions ?? []}
                    error={meta.touched && meta.error ? meta.error : ""}
                  />
                )}
              </Field>
            )}

            {children?.({ isSubmitting, isValid, setFieldValue })}
          </Form>
        );
      }}
    </Formik>
  );
};

export default AppForm;
